import React from 'react';

// Hooks
import { useOnboardingState } from 'Shared/utils/hooks/use-onboarding-state';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import WpIcon from 'Wpds/components/icon/WpIcon';
import OAuthButton from 'Shared/components/OAuthButton/OAuthButton';
import { WpButton, WpButtonGroup } from 'Wpds/components/button';
import SignUpTermsAgreement from 'Shared/components/SignUpTermsAgreement/SignUpTermsAgreement';

// Styles
import './OnboardingSlackAIWelcome.scss';

const OnboardingSlackAIWelcome = () => {
  const { handleAdvanceOnboardingState, isAdvancingForward } = useOnboardingState();

  const baseClassName = 'OnboardingSlackAIWelcome';
  return (
    <div className={baseClassName}>
      <img
        src="https://piprodperformassets.blob.core.windows.net/assets/charma_wrangler.png"
        alt="Automate your agendas"
        className={`${baseClassName}__image`}
      />
      <h1 className={`${baseClassName}__title`}>Automate your agendas</h1>
      <h5 className={`${baseClassName}__description`}>
        Use AI to suggest relevant discussion topics for 1:1s & group meetings.
      </h5>
      <div className={`${baseClassName}__button-wrapper`}>
        <WpButtonGroup stacked>
          <OAuthButton oauthProvider="slack" color="primary" variant="primary" text="Sign up with Slack" />
          <WpButton
            variant="tertiary"
            size="lg"
            block
            onClick={() => handleAdvanceOnboardingState({ didSkip: true })}
            loading={isAdvancingForward}
          >
            Skip
          </WpButton>
        </WpButtonGroup>
      </div>

      <WpContainer className={`${baseClassName}__privacy`}>
        <WpContainerBody>
          <div className={`${baseClassName}__privacy__body`}>
            <WpIcon size="lg" name="lock-alt" />
            <div className={`${baseClassName}__privacy__body__text`}>
              Data privacy: You’re in control; only the Slack channels you select will be used.
            </div>
          </div>
        </WpContainerBody>
      </WpContainer>
      <SignUpTermsAgreement className={`${baseClassName}__terms`} />
    </div>
  );
};

export default OnboardingSlackAIWelcome;
